import { Dialect } from '../dialect.js';
import type { Keyword } from './keywords.js';

/**
 * Η «σωστή» γραφή κάθε δεσμευμένης λέξης στην Ψευδογλώσσα — Κεφαλαίο πρώτο
 * γράμμα, τα υπόλοιπα πεζά, με πλήρη τονισμό. Σε αντίθεση με το
 * `KEYWORD_LIST` (σκόπιμα αποτονισμένο, μόνο για ανεκτική *αναγνώριση* —
 * βλ. σχόλιο εκεί), αυτός ο πίνακας είναι η πηγή "σωστής ορθογραφίας",
 * χρησιμοποιείται π.χ. για αυτόματη διόρθωση καθώς πληκτρολογεί ο μαθητής.
 *
 * Η ΓΛΩΣΣΑ δεν χρειάζεται αντίστοιχο πίνακα: η καθιερωμένη σύμβασή της
 * είναι ΚΕΦΑΛΑΙΑ χωρίς τόνους — ακριβώς η μορφή που ήδη αποθηκεύει το
 * KEYWORD_LIST.
 */
const PSEUDOGLOSSA_DISPLAY: Readonly<Record<Keyword, string>> = {
  ΠΡΟΓΡΑΜΜΑ: 'Πρόγραμμα',
  ΑΛΓΟΡΙΘΜΟΣ: 'Αλγόριθμος',
  ΔΕΔΟΜΕΝΑ: 'Δεδομένα',
  ΑΠΟΤΕΛΕΣΜΑΤΑ: 'Αποτελέσματα',
  ΣΤΑΘΕΡΕΣ: 'Σταθερές',
  ΜΕΤΑΒΛΗΤΕΣ: 'Μεταβλητές',
  ΑΚΕΡΑΙΕΣ: 'Ακέραιες',
  ΠΡΑΓΜΑΤΙΚΕΣ: 'Πραγματικές',
  ΧΑΡΑΚΤΗΡΕΣ: 'Χαρακτήρες',
  ΛΟΓΙΚΕΣ: 'Λογικές',
  ΑΚΕΡΑΙΑ: 'Ακέραια',
  ΠΡΑΓΜΑΤΙΚΗ: 'Πραγματική',
  ΧΑΡΑΚΤΗΡΑΣ: 'Χαρακτήρας',
  ΛΟΓΙΚΗ: 'Λογική',
  ΑΡΧΗ: 'Αρχή',
  ΤΕΛΟΣ_ΠΡΟΓΡΑΜΜΑΤΟΣ: 'Τέλος_προγράμματος',
  ΤΕΛΟΣ: 'Τέλος',
  ΔΙΑΔΙΚΑΣΙΑ: 'Διαδικασία',
  ΤΕΛΟΣ_ΔΙΑΔΙΚΑΣΙΑΣ: 'Τέλος_διαδικασίας',
  ΣΥΝΑΡΤΗΣΗ: 'Συνάρτηση',
  ΤΕΛΟΣ_ΣΥΝΑΡΤΗΣΗΣ: 'Τέλος_συνάρτησης',
  ΚΑΛΕΣΕ: 'Κάλεσε',
  ΔΙΑΒΑΣΕ: 'Διάβασε',
  ΓΡΑΨΕ: 'Γράψε',
  ΕΚΤΥΠΩΣΕ: 'Εκτύπωσε',
  ΕΜΦΑΝΙΣΕ: 'Εμφάνισε',
  ΑΝΤΙΜΕΤΑΘΕΣΕ: 'Αντιμετάθεσε',
  ΑΝ: 'Αν',
  ΤΟΤΕ: 'Τότε',
  ΑΛΛΙΩΣ_ΑΝ: 'Αλλιώς_αν',
  ΑΛΛΙΩΣ: 'Αλλιώς',
  ΤΕΛΟΣ_ΑΝ: 'Τέλος_αν',
  ΕΠΙΛΕΞΕ: 'Επίλεξε',
  ΠΕΡΙΠΤΩΣΗ: 'Περίπτωση',
  ΤΕΛΟΣ_ΕΠΙΛΟΓΩΝ: 'Τέλος_επιλογών',
  ΓΙΑ: 'Για',
  ΑΠΟ: 'Από',
  ΜΕΧΡΙ: 'Μέχρι',
  ΜΕ_ΒΗΜΑ: 'Με_βήμα',
  ΤΕΛΟΣ_ΕΠΑΝΑΛΗΨΗΣ: 'Τέλος_επανάληψης',
  ΟΣΟ: 'Όσο',
  ΕΠΑΝΑΛΑΒΕ: 'Επανάλαβε',
  ΑΡΧΗ_ΕΠΑΝΑΛΗΨΗΣ: 'Αρχή_επανάληψης',
  ΜΕΧΡΙΣ_ΟΤΟΥ: 'Μέχρις_ότου',
  ΚΑΙ: 'Και',
  Η: 'Ή',
  ΟΧΙ: 'Όχι',
  DIV: 'div',
  MOD: 'mod',
  ΑΛΗΘΗΣ: 'Αληθής',
  ΨΕΥΔΗΣ: 'Ψευδής',
};

/** Η σωστή γραφή μιας δεσμευμένης λέξης, ανάλογα με τη διάλεκτο. */
export function keywordDisplayForm(keyword: Keyword, dialect: Dialect): string {
  return dialect === Dialect.GLOSSA ? keyword : PSEUDOGLOSSA_DISPLAY[keyword];
}
